import { useEffect, useRef } from 'react';
import { EventDetails } from '../lib/api';
import { ContactForm } from './ContactForm';
import { useAnimatedClose } from '../hooks/useAnimatedClose';

export function EventPanel({ open, event, onClose }: { open: boolean; event: EventDetails | null; onClose: () => void }) {
  const closeRef = useRef<HTMLButtonElement>(null);
  const { closing, requestClose } = useAnimatedClose(onClose);
  useEffect(() => { if (open) closeRef.current?.focus(); }, [open]);
  if (!open || !event) return null;
  return (
    <div className={`modal-backdrop ${closing ? 'is-closing' : ''}`} role="presentation" onMouseDown={(e) => { if (e.target === e.currentTarget) requestClose(); }}>
      <section className="event-panel" role="dialog" aria-modal="true" aria-labelledby="event-title">
        <button ref={closeRef} className="icon-button" onClick={() => requestClose()} aria-label="Close event details">×</button>
        <p className="eyebrow">The particulars</p>
        <h2 id="event-title">{event.title}</h2>
        {event.surpriseParty && <div className="surprise-strip">SHHH... IT'S A SURPRISE.</div>}
        <dl className="event-facts">
          <div><dt><i className="fa-regular fa-calendar-days" aria-hidden="true" /> When</dt><dd>{event.date}<br />{event.startTime}–{event.endTime}</dd></div>
          <div><dt><i className="fa-solid fa-location-dot" aria-hidden="true" /> Where</dt><dd>{event.venueName}<br />{event.address}</dd></div>
          <div><dt><i className="fa-regular fa-clock" aria-hidden="true" /> Arrive by</dt><dd>{event.guestArrivalTime}<br /><small>Jeff rolls in around {event.honoreeArrivalTime}</small></dd></div>
          <div><dt><i className="fa-solid fa-reply" aria-hidden="true" /> RSVP by</dt><dd>{event.rsvpDeadline}</dd></div>
        </dl>
        <p className="gift-notice"><i className="fa-solid fa-gift" aria-hidden="true" /><strong>No gifts, please. Your presence is our present!</strong></p>
        <a className="button secondary full" href={event.mapUrl} target="_blank" rel="noreferrer"><i className="fa-solid fa-location-dot" aria-hidden="true" /> Map &amp; directions</a>
        <div className="event-notes">
          <p><i className="fa-solid fa-champagne-glasses" aria-hidden="true" /><span>{event.eventNotes.arrival}</span></p><p><i className="fa-solid fa-square-parking" aria-hidden="true" /><span><strong>Parking:</strong> {event.eventNotes.parking}</span></p>
          <p><i className="fa-solid fa-shirt" aria-hidden="true" /><span><strong>Attire:</strong> {event.eventNotes.attire}</span></p><p><i className="fa-solid fa-utensils" aria-hidden="true" /><span><strong>Food &amp; Drink:</strong> {event.eventNotes.food}</span></p>
        </div>
        <ContactForm />
      </section>
    </div>
  );
}
